// extracted by mini-css-extract-plugin
export var content = "_7m-3";
export var list = "_7m-4";
export var settingsContent = "_7m-7";
export var settingsPanel = "_7m-8";
export var state = "_7m-6";
export var triggerBadge = "_7m-2";
export var triggerButton = "_7m-1";
export var triggerShell = "_7m-0";
export var unreadDot = "_7m-5";